import { InputBase } from './input-base';

export class InputRadio extends InputBase<string> {
	controlType = 'radio';

	options: { key: string; value: string; disabled: boolean }[] = [];

	constructor(options: any = {}) {
		super(options);
		this.options = options.options || [];
	}
}
